import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class TokenStatusService {

  baseEndpoint;

  constructor(
    private http: HttpClient
    ) {
    this.baseEndpoint = environment.apiUser
  }

  verifyTokenStatus(): Observable<any> {
    const url = `${this.baseEndpoint}/token/status`;
    return this.http.get(url);
  }
}
